import packageData from '../../../../package.json';

export default {
	name: 'Footer',
	
	data() {
		return {
			version: `v${packageData.version}`,
			year: new Date().getFullYear(),
		};
	},
};
